import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import { Field, Form, Formik } from "formik"
import { TextField } from "formik-material-ui"
import { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import * as Yup from "yup"
import { createLabInstance } from "~/actions/labs"
import CounterHeader from "~/components/Common/CounterHeader"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const CreateInstanceDialog = () => {
  const classes = useStyles()
  const queryClient = useQueryClient()
  const { dialogs, closeDialog, openSnackBar } = useContext(AppContext)
  const thisDialog = dialogs?.["createInstanceDialog"] || {}
  const { open = false, data } = thisDialog
  const openErrorSnackbar = useOpenErrorSnackbar()
  const lab = data?.lab

  const createInstanceMutation = useMutation((data) =>
    createLabInstance(data, lab.id),
  )

  const handleClose = () => {
    closeDialog("createInstanceDialog")
  }

  const onSubmit = (values, actions) => {
    createInstanceMutation.mutate(values, {
      onSuccess: (res) => {
        queryClient.setQueryData(["lab", lab.id], (oldData) => {
          return res
        })
        openSnackBar({ message: "Created Lab Instance" })
        handleClose()
      },
      onError: (err) => {
        openErrorSnackbar(err, "Error Creating Instance")
      },
      onSettled: () => {
        actions.setSubmitting(false)
      },
    })
  }

  const schema = Yup.object().shape({
    name: Yup.string()
      .required(`Please enter a name`)
      .max(50, "Name must be less than 50 characters"),
  })

  return (
    <Dialog open={open}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h2" className={classes.title}>
          Add Instance
        </Typography>
        <Typography color="primary" variant="subtitle2">
          Create a new Instance
        </Typography>
      </DialogTitle>
      <Formik
        initialValues={{
          name: "",
        }}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({ values, isSubmitting }) => (
          <Form>
            <DialogContent>
              <Box>
                <CounterHeader title="Name" value={values.name} max={50} />
                <Field
                  name="name"
                  component={TextField}
                  variant="filled"
                  fullWidth
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} style={{ height: "40px" }}>
                Cancel
              </Button>
              <LoaderButton
                type="submit"
                classoverrides={{
                  wrapper: classes.button,
                  button: {
                    root: classes.buttonRoot,
                  },
                }}
                variant="contained"
                color="secondary"
                working={isSubmitting}
                size="small"
              >
                Add
              </LoaderButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default CreateInstanceDialog
